import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px', height:'100vh'}}>
      <h1>404 - Page Not Found</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
      <Link to="/" style={{color:'blue', textDecoration:'none'}}>Go to Home</Link>
    </div>
  );
}

export default NotFound;
